(ns io.daskul.webapp.widgets.form.advanced-fields
  "Pure split logic for progressive-disclosure forms (SMS-106).

   Separated from the `advanced-section` layout widget so it carries no UI
   dependency and can be unit-tested under the :node-test target (which cannot
   load the browser-only `io.daskul.webapp.ui` / icon modules). This mirrors the
   existing webapp-ui test convention: pure logic is node-tested, layout is
   e2e-verified. See frontend-component-architecture.md (separate logic from
   layout).")

(defn split-fields
  "Split a vector of form-field maps into {:primary [...] :advanced [...]},
   preserving original order within each group.

   `advanced-keys` is a set of field-name keywords; any field whose :name is in
   the set goes to :advanced, the rest to :primary. Nil/empty `advanced-keys`
   means everything is primary (advanced empty) — so call sites that pass no
   advanced set behave exactly as a flat form."
  [fields advanced-keys]
  (let [advanced-keys (or advanced-keys #{})]
    (reduce (fn [acc field]
              (if (contains? advanced-keys (:name field))
                (update acc :advanced conj field)
                (update acc :primary conj field)))
            {:primary [] :advanced []}
            fields)))
